import { useEffect } from "react";
import Game from "../../store/Game";
import { demonstrationStore } from "../../store/Demonstration";

export default function useViewController() {
  useEffect(() => {
    const game = Game.game;
    if (game) {
      Game.getZones(game.id);
    }
  }, []);

  useEffect(() => {
    const game = Game.game;
    if (game) {
      if (!Game.isZonesLoading && !demonstrationStore.finished) {
        // hotfix: finger-demo указывает на карточку результата. Если карточек нет
        // (пустые зоны — например, партнёр ещё не прошёл тест: «0 из 145 карт»),
        // указывать не на что → подсказка «застревала» в верхнем-левом углу, а её
        // полноэкранный оверлей (z-index 99999) перехватывал ВСЕ клики, включая
        // баннер cookie. В таком случае демо не открываем.
        const hasResultCards = Game.zones.some(
          (z) => z.kind !== "personal" && z.cards.length > 0
        );
        if (hasResultCards) {
          demonstrationStore.openDemonstration(game);
        }
      }
    }
  }, [Game.isZonesLoading]);

  return {};
}
